import { render } from "./Index.vue?vue&type=template&id=2e08e318&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=2e08e318&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e08e318"]])

export default __exports__